(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["modal-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    let pressedOn = null;

    document.addEventListener('pointerdown', (event) => (pressedOn = event.target), true);

    document.addEventListener('click', (event) => {
      const closer = event.target.closest('[data-modal-close]');
      const owner = closer?.closest('dialog[data-modal]');
      if (owner) {
        owner.close();
        return;
      }

      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-modal]') || pressedOn !== dialog) return;
      if (dialog.dataset.modal !== 'scrim') {
        const box = dialog.getBoundingClientRect();
        const inside =
          event.clientX >= box.left &&
          event.clientX <= box.right &&
          event.clientY >= box.top &&
          event.clientY <= box.bottom;
        if (inside) return;
      }
      dialog.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const dialog = event.target.closest?.('dialog[data-modal][open]');
      if (!dialog) return;
      event.preventDefault();
      dialog.close();
    });

    // `close` doesn't bubble; the capture phase still reaches the document.
    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-modal]') || !dialog.id) return;
        for (const toggle of document.querySelectorAll(`[aria-controls="${CSS.escape(dialog.id)}"]`)) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      },
      true,
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    /*
    Thumbnails switch the large view; a video that is switched away from stops playing. When the
    thumbnails overflow their row, the arrows page through it and the chosen one takes the middle
    of the row wherever the row can scroll that far.
  */
  class ProductGallery extends HTMLElement {
    #abort;
    #resize;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.addEventListener(
        'click',
        (event) => {
          const thumb = event.target.closest('[data-media-target]');
          if (thumb) this.show(thumb.dataset.mediaTarget);
          // data-page, not data-step: the product form around the gallery reads data-step as its
          // quantity buttons, so a click here would also change the quantity.
          const page = event.target.closest('[data-page]');
          if (page) this.#page(Number(page.dataset.page));
        },
        { signal },
      );

      const row = this.#row();
      if (!row) return;
      row.addEventListener('scroll', () => this.#updateEnds(), { signal, passive: true });
      this.#resize = new ResizeObserver(() => this.#updateEnds());
      this.#resize.observe(row);
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#resize?.disconnect();
    }

    #row() {
      return this.querySelector('.gallery__thumbs');
    }

    #behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    /* Marks which ends of the row have more thumbnails past them. */
    #updateEnds() {
      const row = this.#row();
      const strip = row?.parentElement;
      if (!strip) return;
      const end = row.scrollWidth - row.clientWidth;
      strip.toggleAttribute('data-at-start', row.scrollLeft <= 1);
      strip.toggleAttribute('data-at-end', row.scrollLeft >= end - 1);
    }

    /* Moves the row by most of its width, so the last thumbnail seen stays in sight. */
    #page(direction) {
      const row = this.#row();
      row?.scrollBy({ left: direction * row.clientWidth * 0.8, behavior: this.#behavior() });
    }

    /*
      Puts the chosen thumbnail in the middle of the row. The thumbnails within half a row of
      either end can't be centred, so the row goes as far that way as it can instead: to its
      start for the first few, to its end for the last few.
    */
    #reveal(thumb) {
      const row = this.#row();
      const item = thumb.parentElement;
      if (!row || !item) return;

      const centred = item.offsetLeft + item.offsetWidth / 2 - row.clientWidth / 2;
      const max = row.scrollWidth - row.clientWidth;
      const left = Math.max(0, Math.min(centred, max));

      if (Math.abs(left - row.scrollLeft) > 1) {
        row.scrollTo({ left, behavior: this.#behavior() });
      }
    }

    show(mediaId) {
      for (const view of this.querySelectorAll('[data-media-id]')) {
        const active = view.dataset.mediaId === String(mediaId);
        if (!active && !view.hidden) {
          view.querySelector('video')?.pause();
          // YouTube and Vimeo embeds have no pause from here; reloading the frame stops them.
          const iframe = view.querySelector('iframe');
          if (iframe) iframe.src = iframe.src;
        }
        view.hidden = !active;
      }
      for (const thumb of this.querySelectorAll('[data-media-target]')) {
        const current = thumb.dataset.mediaTarget === String(mediaId);
        thumb.setAttribute('aria-current', String(current));
        if (current) this.#reveal(thumb);
      }
    }
  }

  customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    class SearchOverlay extends HTMLElement {
    #abort = new AbortController();
    #request;
    #timer;
    #cache = new Map();

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.dialog = this.querySelector('[data-search-dialog]');
      this.input = this.querySelector('[data-search-input]');
      this.resultsSlot = this.querySelector('[data-search-results-slot]');
      this.status = this.querySelector('[data-search-status]');

      document.addEventListener(
        'click',
        (event) => {
          // Modified clicks still open /search in a new tab or window.
          if (!event.target.closest('[data-search-open]') || SearchOverlay.#isModified(event)) return;
          event.preventDefault();
          this.open();
        },
        { signal },
      );

      this.input.addEventListener(
        'input',
        () => {
          clearTimeout(this.#timer);
          this.#timer = setTimeout(() => this.#search(), 250);
        },
        { signal },
      );

      // Scrim, Escape, the close button and aria-expanded on close: snippets/modal-dialog.liquid.
      this.dialog.addEventListener('click', (event) => this.#onClick(event), { signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#request?.abort();
      clearTimeout(this.#timer);
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      document.querySelectorAll('[data-search-open]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
      this.input.focus();
      this.input.select();
      if (this.input.value.trim()) this.#search();
    }

    #onClick(event) {
      const chip = event.target.closest('[data-search-term]');
      if (chip && !SearchOverlay.#isModified(event)) {
        event.preventDefault();
        this.input.value = chip.dataset.searchTerm;
        this.input.focus();
        this.#search();
      }
    }

    /* Fetches the results section for the current terms; the latest request always wins. */
    async #search() {
      clearTimeout(this.#timer);
      const terms = this.input.value.trim();
      this.#request?.abort();

      if (!terms) {
        this.resultsSlot.replaceChildren();
        this.resultsSlot.removeAttribute('aria-busy');
        this.status.textContent = '';
        return;
      }

      const cached = this.#cache.get(terms);
      if (cached) {
        this.#show(cached);
        return;
      }

      const params = new URLSearchParams({
        q: terms,
        section_id: 'predictive-search',
        'resources[type]': 'product,article',
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag,body',
      });
      this.#request = new AbortController();
      this.resultsSlot.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.#request.signal });
        if (!response.ok) throw new Error(response.statusText);
        const html = await response.text();
        const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-results]');
        if (!results) throw new Error('No results section');
        this.#cache.set(terms, results);
        this.#show(results);
      } catch (error) {
        if (error.name === 'AbortError') return;
        const message = document.createElement('p');
        message.className = 'predictive-results__none';
        message.textContent = this.dataset.error;
        this.resultsSlot.replaceChildren(message);
        this.resultsSlot.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.error;
      }
    }

    /* The status line lives outside the swapped content so screen readers announce each update. */
    #show(results) {
      this.resultsSlot.replaceChildren(results.cloneNode(true));
      this.resultsSlot.removeAttribute('aria-busy');
      this.status.textContent = results.dataset.status ?? '';
    }

    static #isModified(event) {
      return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
    }
  }

  customElements.define('search-overlay', SearchOverlay);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    /* Copies the page's link, telling the customer either way; the share links are plain anchors. */
  class ShareButtons extends HTMLElement {
    #abort;
    #timer = 0;

    connectedCallback() {
      this.#abort = new AbortController();
      this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#abort.signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
      clearTimeout(this.#timer);
    }

    async #onClick(event) {
      const button = event.target.closest('[data-copy]');
      if (!button) return;

      const status = this.querySelector('[data-status]');
      clearTimeout(this.#timer);
      try {
        await navigator.clipboard.writeText(button.dataset.copy);
        status.textContent = button.dataset.copied;
      } catch {
        // Clipboard blocked (no permission, or an insecure context): say so rather than fail silently.
        status.textContent = button.dataset.copyFailed;
      }
      this.#timer = setTimeout(() => {
        status.textContent = '';
      }, 2000);
    }
  }

  customElements.define('share-buttons', ShareButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tab-list"] && !Shopify.designMode) return;
  try {
    class TabList extends HTMLElement {
    #abort;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.addEventListener(
        'click',
        (event) => {
          const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
          if (index > -1) this.select(index);
        },
        { signal },
      );
      this.addEventListener('keydown', (event) => this.#onKey(event), { signal });
      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index > -1) this.select(index);
        },
        { signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    get tabs() {
      return [...this.querySelectorAll('[role="tab"]')];
    }

    /* `scroll: false` for a quiet reset that shouldn't move the page, e.g. after clearing a search. */
    select(index, { focus = false, scroll = true } = {}) {
      const tabs = this.tabs;
      const chosen = tabs[index];
      if (!chosen) return;
      tabs.forEach((tab) => {
        const selected = tab === chosen;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (this.hasAttribute('data-panels-always-visible')) return;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) chosen.focus();
      if (scroll) chosen.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.dispatchEvent(new CustomEvent('tab-list:change', { bubbles: true, detail: { index } }));
    }

    #onKey(event) {
      const tabs = this.tabs;
      const index = tabs.indexOf(event.target.closest('[role="tab"]'));
      if (index === -1) return;
      const vertical = this.getAttribute('aria-orientation') === 'vertical';
      const steps = { ArrowRight: 1, ArrowLeft: -1 };
      if (vertical) Object.assign(steps, { ArrowDown: 1, ArrowUp: -1 });
      let next;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else if (steps[event.key]) next = (index + steps[event.key] + tabs.length) % tabs.length;
      else return;
      event.preventDefault();
      this.select(next, { focus: true });
    }
  }

  customElements.define('tab-list', TabList);
  } catch(e) { console.error(e); }
})();

})();
